import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchFlInventoryAttachments = (id) =>
  apiActionCreator({
    'endpoint': `/floating-inventory-files?id=${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOATING_INVENTORY_ATTACHMENTS,
      ActionTypes.FETCHED_FLOATING_INVENTORY_ATTACHMENTS,
      [
        ActionTypes.FETCHED_FLOATING_INVENTORY_ATTACHMENTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });

export const saveFlInventoryAttachments = (data, fileType, id) => {
  return apiActionCreator({
    'endpoint': `/floating-inventory-files/${fileType}?id=${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_FLOATING_INVENTORY_ATTACHMENTS,
      [
        ActionTypes.SAVED_FLOATING_INVENTORY_ATTACHMENTS,
        MessageActions.addMessageBoxInfo('Archivos guardados existosamente'),
      ],
      [
        ActionTypes.SAVED_FLOATING_INVENTORY_ATTACHMENTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'POST',
    data,
  });
};

export const openModalInventoryFiles = (value) => ({
  'type': ActionTypes.OPEN_MODAL_INV_FILES,
  'payload': value,
});

export const setDisableModalInventoryFiles = (value) => ({
  'type': ActionTypes.SET_DISABLE_INVENTORY_FILES,
  'payload': value,
});

export const setClientCurrFiles = (value) => ({
  'type': ActionTypes.SET_CURRENT_CLIENT_FILES,
  'payload': value,
});

export const setInfoCertCurrFiles = (value) => ({
  'type': ActionTypes.SET_CURRENT_INFO_CERT_FILES,
  'payload': value,
});

export const setOthersCurrFiles = (value) => ({
  'type': ActionTypes.SET_CURRENT_OTHERS_FILES,
  'payload': value,
});

export const clearFlInventoryFiles = (value) => ({
  'type': ActionTypes.CLEAR_FL_INVENTORY_FILES,
  'payload': value,
});
